/**
 * Stats Block — custom vertical carousel.
 *
 * Each slide is absolutely positioned. JS sets translateY + opacity.
 * STEP = vertical distance between each slide's centre (px).
 * The carousel container (height set in SCSS) is the visible clip area.
 *
 * @package UnderstrapChild
 */

function initStatsBlock( root ) {
	if ( ! root ) return;

	var carousel = root.querySelector( '[data-stats-carousel]' );
	if ( ! carousel ) return;

	var slides = Array.prototype.slice.call( carousel.querySelectorAll( '.stats-block__slide' ) );
	var total  = slides.length;
	if ( ! total ) return;

	var current   = 0;
	var paused    = false;
	var autoTimer = null;

	// Vertical distance between each slide centre (px). Smaller = closer together.
	var STEP_DESKTOP = 180;
	var STEP_MOBILE  = 130;

	// Auto-cycle interval in ms.
	var INTERVAL = 3500;

	function goTo( index ) {
		current = ( ( index % total ) + total ) % total;
		var step = window.matchMedia( '(max-width: 767px)' ).matches ? STEP_MOBILE : STEP_DESKTOP;

		slides.forEach( function ( slide, i ) {
			var offset = i - current;

			// Wrap for loop-around.
			if ( offset > Math.floor( total / 2 ) )  offset -= total;
			if ( offset < -Math.floor( total / 2 ) ) offset += total;

			var isActive   = offset === 0;
			var isAdjacent = Math.abs( offset ) === 1;

			slide.style.transform = 'translateY(calc(-50% + ' + ( offset * step ) + 'px)) scale(' + ( isActive ? 1 : 0.75 ) + ')';
			slide.style.opacity   = isActive ? '1' : ( offset < 0 ? '0.05' : ( isAdjacent ? '0.3' : '0' ) );
			slide.classList.toggle( 'is-active', isActive );
			slide.setAttribute( 'aria-hidden', isActive ? 'false' : 'true' );
		} );
	}

	function startAuto() {
		stopAuto();
		autoTimer = setInterval( function () {
			if ( ! paused ) goTo( current + 1 );
		}, INTERVAL );
	}

	function stopAuto() {
		if ( autoTimer ) {
			clearInterval( autoTimer );
			autoTimer = null;
		}
	}

	goTo( 0 );
	startAuto();

	document.addEventListener( 'visibilitychange', function () {
		paused = document.hidden;
	} );
}

// ── Frontend ──────────────────────────────────────────────────────────────────
document.addEventListener( 'DOMContentLoaded', function () {
	initStatsBlock( document.querySelector( '[data-stats-block]' ) );
} );

// ── Block editor preview (ACF) ────────────────────────────────────────────────
if ( typeof acf !== 'undefined' ) {
	acf.addAction( 'render_block_preview/type=stats-block', function ( $el ) {
		var root = ( $el && $el[0] ) ? $el[0].querySelector( '[data-stats-block]' ) : null;
		initStatsBlock( root );
	} );
}
